import {Container, Alert, Row, Col} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import elements from "../../../styles/settings/elements.module.scss";
import classes from "../../../styles/apps/my-ip.module.scss";
import VerticalAd from "../../../components/adsense/VericalAd";
import {LEFT_SLOT, RIGHT_SLOT, SLOT1, SLOT2} from "../../../storage/constants/adsense";
import TrendingApps from "../../../components/TrendingApps";
import HorizontalAd from "../../../components/adsense/HorizontalAd";
import TrendingGames from "../../../components/TrendingGames";

export default function MyIP() {
    const [IP, setIP] = useState('loading...');

    useEffect(() => {
        getIP();
    }, []);

    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(IP)
            .then(() => {
                setCopied(true);
                // Hide alert after 2 seconds
                setTimeout(() => setCopied(false), 2000);
            })
            .catch(err => console.error("Failed to copy text", err));
    };

    const getIP = async () => {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            console.log(data)
            setIP(data.ip);
        } catch (error) {
            console.error('Error fetching IP address:', error);
            setIP('null');
        }
    }

    return (
        <>
            <Helmet>
                <title>My IP</title>
                <meta
                    name="description"
                    content="Instantly discover your public IP address using our free, secure tool—no registration needed."
                />
            </Helmet>


            <Container fluid>
                <Row>
                    <Col xl={2} className="d-none d-xl-flex justify-content-center">
                        <VerticalAd adSlot={LEFT_SLOT} />
                    </Col>

                    <Col xs={12} xl={8} className={elements.mainContent}>
                        <header className={elements.introduction}>
                            <h1 className={elements.title}>My IP</h1>
                            <p className={elements.description}>
                                Get IP address based on your current location.
                            </p>
                        </header>

                        <HorizontalAd adSlot={SLOT1} />

                        <p className={classes.ip} onClick={handleCopy}>{IP}</p>

                        <HorizontalAd adSlot={SLOT2} />

                        {copied && (
                            <Alert variant="success" className={classes.alert}>
                                Copied!
                            </Alert>
                        )}
                    </Col>

                    <Col xl={2} className="d-none d-xl-flex justify-content-center">
                        <VerticalAd adSlot={RIGHT_SLOT} />
                    </Col>
                </Row>
            </Container>
        </>
    );
}